import React, { useEffect, useState } from "react";
import Logo3D from "./Three.js/Logo3D";
import BurgerMenu from "./BurgerMenu";
import "../styles/HeaderNormal.css";


const Header = () => {
  const [isShrunk, setIsShrunk] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const currentPath = window.location.pathname;

  const isActive = (path) => currentPath === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsShrunk(window.scrollY > 0);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) return <BurgerMenu />;

  return (
    <>
      <div className='headerNormal' >
        <nav>
          <ul className={`HeaderNormalNavMenu ${isShrunk ? "shrunkNormal" : ""}`}>
            <li><a id="accueil" href="/" className={isActive('/') ? 'active' : ''}>Accueil</a></li>
            <li><a id="voyagez" href="/voyagez" className={isActive('/voyagez') ? 'active' : ''}>Voyagez avec nous</a></li>
            <li><a id="charter" href="/charter" className={isActive('/charter') ? 'active' : ''}>Charter</a></li>
            <li className="logo" id="logo"><a href="/"><Logo3D /></a></li>
            <li><a id="realisation" href="/realisation" className={isActive('/realisation') ? 'active' : ''}>Nos Réalisations</a></li>
            <li><a id="contact" href="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</a></li>
            <li><a id="decouvrir" href="/decouvrir" className={isActive('/decouvrir') ? 'active' : ''}>Découvrir</a></li>
          </ul>
        </nav>

      </div>

    </>
  );
};

export default Header;
